<template>
    <b-modal title="Distinta Base" ref="mdlArticoliDistintaBase" id="mdlArticoliDistintaBase" @shown="onShownModal"
        size="lg" @ok="onOk">
        <div class="sa-tab-scroll">
            <div class="sa-flexbox">
                <div class="sa-flexbox-header">
                    <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-1">
                            <label class="sa-label-data">Articolo Distinta Base:</label>
                            <b-form-input v-model="jsonData.nomeArticolo" :disabled="true" value-field="idDistintaBase"
                                text-field="nome"></b-form-input>
                        </b-col>
                    </b-row>
                </div>
                <div class="sa-flexbox-body">
                    <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-1">
                            <b-row class="mb-2">
                                <b-col cols="4">
                                    <label class="sa-label-data">Nome Articolo</label>
                                    <b-form-input v-model="filter.nomeArticolo"></b-form-input>
                                </b-col>
                                <b-col cols="4">
                                    <label class="sa-label-data">Codice AIC</label>
                                    <b-form-input v-model="filter.codiceAic"></b-form-input>
                                </b-col>
                            </b-row>
                            <div style="height: 350px; max-height: 350px; overflow-y: scroll;">
                                <MagazzinoArticoliListComponent :tableHideColumn="['actions']" :sessionFilter="false"
                                    @updateFilter="updateFilter" @onRowSelectedArticoliItems="onRowSelected"
                                    :selectable="true" ref="cmpMagazzinoArticoliListComponent" />
                            </div>
                            <small class="p-3">Articolo Selezionato: <b v-if="articoloSelezionato != null"> {{
                                articoloSelezionato.nomeArticolo }}</b></small>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
import MagazzinoArticoliListComponent from "./MagazzinoArticoliListComponent.vue"
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin, MagazzinoMixins],
    components: { MagazzinoArticoliListComponent },
    mounted() {
        this.mangazzinoArticoliUnitaMisuraLoadData();
    },
    data() {
        return {
            pathResource: "/magazzinoarticoli",
            jsonData: { nomeArticolo: null, codiceAzienda: null, descrizione: null, codice: null, tipo: null, idListinoBase: null, tipoCalcolo: null, valoreRincaroPercentuale: null, prezzoSoccorso: null, usaPrezzoBaseSeNullo: true, alertPrezzoZero: true },
            id: "",
            articoloSelezionatoOption: [],
            struttureOptions: [],
            magazzinoListiniOptions: [],
            articoliOptions: [],
            filter: { nomeArticolo: null, forPage: 100, page: 1 },
            articoloSelezionato: null
        };
    },
    watch: {
        'filter.nomeArticolo': function (params) {
            if (params.length > 2) {
                this.onRicercaArticolo();
            }
        },
        'filter.codiceAic': function (params) {
            if (params.length > 1) {
                this.onRicercaArticolo();
            }
        }
    },

    methods: {
        init(filtro = null, articolo) {
            this.id = filtro.idArticolo;
            this.jsonData = articolo;
            this.nuovoArticolo = false;
            if (this.id == null || this.id == "-1") {
                this.nuovoArticolo = true;
            }
            this.open();
        },
        open() {
            this.$refs.mdlArticoliDistintaBase.show();
        },
        close() {
            this.$refs.mdlArticoliDistintaBase.hide();
        },

        onShownModal() {
            this.$refs.cmpMagazzinoArticoliListComponent.loadDataArticoli(this.filter);
            this.articoloSelezionato = null;
        },
        onOk(bvModalEvent) {
            bvModalEvent.preventDefault();
            let descrizione = this.magazzinoArticoliUnitaMisuraOptions.filter(e => e.id == this.articoloSelezionato.umId)[0].descrizioneMultiplo
            let item = {
                idArticolo: this.articoloSelezionato.id,
                descrizioneArticolo: this.articoloSelezionato.nomeArticolo,
                quantita: 1,
                idUm: this.articoloSelezionato.umId,
                descrizioneUm: descrizione ? descrizione : "NON DEFINITO"
            };
            this.$emit("onAddArticolo", item);
            this.$nextTick(() => {
                this.close();
            });

        },
        onRowSelected(row) {
            if (row[0]) {
                let item = row[0];
                this.articoloSelezionato = item;
            }
        },
        onRicercaArticolo() {
            this.$refs.cmpMagazzinoArticoliListComponent.loadDataArticoli(this.filter);
        },
        updateFilter(filter) {
            this.filter = filter;
        },
        resultResponseSave() {
            this.$emit("afterSave");
            this.$refs.mdlMagazzinoListini.hide();
        }
    },
};
</script>

<style></style>
